export const STOP_LIST_FILTERS_STORAGE_KEY = 'stop-list-management::filters' // unique namespace for filters

export const defaultFilters = Object.freeze({
    divisionId: null, // ID выбранного ресторана
    status: 'all', // 'Все', 'В стоп-листе', 'Не в стоп-листе'
    search: '', // Поисковая строка для блюд
    categoryId: null, // ID выбранной категории
})

const allowedStatuses = new Set(['all', 'in_stoplist', 'not_in_stoplist'])

export const restoreFiltersFromStorage = () => {
    if (typeof window === 'undefined') {
        return { ...defaultFilters }
    }

    try {
        const stored = window.localStorage.getItem(
            STOP_LIST_FILTERS_STORAGE_KEY
        )
        if (!stored) {
            return { ...defaultFilters }
        }

        const parsed = JSON.parse(stored)

        const status = allowedStatuses.has(parsed?.status)
            ? parsed.status
            : defaultFilters.status

        return {
            ...defaultFilters,
            ...parsed,
            status,
        }
    } catch (error) {
        console.warn('Failed to restore stop-list filters from storage', error)
        return { ...defaultFilters }
    }
}

export const persistFiltersToStorage = filters => {
    if (typeof window === 'undefined') return

    try {
        const payload = {
            divisionId: filters?.divisionId ?? null,
            status: allowedStatuses.has(filters?.status)
                ? filters.status
                : defaultFilters.status,
            search: typeof filters?.search === 'string' ? filters.search : '',
            categoryId: filters?.categoryId ?? null,
        }

        window.localStorage.setItem(
            STOP_LIST_FILTERS_STORAGE_KEY,
            JSON.stringify(payload)
        )
    } catch (error) {
        console.warn('Failed to persist stop-list filters to storage', error)
    }
}

export const buildCategoryMap = categories => {
    const map = new Map()

    const collect = nodes => {
        if (!Array.isArray(nodes)) return

        nodes.forEach(node => {
            if (!node || typeof node.id === 'undefined') return
            map.set(node.id, node.name)
            collect(node.children)
        })
    }

    collect(categories)
    return map
}
